<script setup lang="ts">
import Icon from '@components/Icon.vue';
import Typography from '@components/Typography.vue';
import Button from '@components/Button.vue';

defineProps<{ icon?: string }>();
</script>

<template>
  <Button class="menu-item">
    <Icon
      v-if="icon"
      :name="icon"
      height="24"
      width="24"
    />

    <Typography variant="body">
      <slot />
    </Typography>
  </Button>
</template>
